import t from "./typeof.mjs";
import f from "./toPrimitive.mjs";
function n(o) {
  var r = f(o, "string");
  return t(r) === "symbol" ? r : String(r);
}
export {
  n as default
};
//# sourceMappingURL=toPropertyKey.mjs.map
